import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-hdgl",
  "use": "icon-hdgl-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-hdgl\">\r\n<path id=\"icon-hdgl_路径_1949-2\" d=\"M10.4,1.8c-2.6-1-6.8,0-6.8,0V1.5c0-0.7-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2v16.9\r\n\tc0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2v-5c0,0,4-1.3,6.8,0s8.5,0,8.5,0V1.8C18.9,1.8,13,2.8,10.4,1.8L10.4,1.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol